import { render, staticRenderFns } from "./GroupedLessonsList.vue?vue&type=template&id=1d756c5b&scoped=true&"
import script from "./GroupedLessonsList.vue?vue&type=script&lang=ts&"
export * from "./GroupedLessonsList.vue?vue&type=script&lang=ts&"
import style0 from "./GroupedLessonsList.vue?vue&type=style&index=0&id=1d756c5b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d756c5b",
  null
  
)

export default component.exports